import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The carnival the carnival",
  "description": "",
  "published": "2008-05-29T00:00:00.000Z",
  "redirect_from": ["/blog/the-carnival-the-carnival/swizec/107"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Went to the carnival yesterday and let me just tell you straight off that it ... was ... AWESOME! Sure I spent shitloads of money and yes I didn't win anything worth my money, but who the hell cares, it was fun.`}</p>
    <p>{`Going to the carnival one must understand that they're not going there to win stuff, it's actually more along the lines of paying for the ability to play a fun game and the thrill of hoping to win something awesome like a giant fluffy toy. You must also understand that all the games are rigged so that it's nearly impossible to beat them unless your aim is dead perfect or you've had thousands of plays of practice, which, unless you're somewhat insane, you haven't.`}</p>
    <p>{`There's only one thing that's dead simple to beat - the duck catch. There's plastic duckies floating in some water and you fetch them out with a long stick. Unless you're a fumbling idiot you should be able to get all seven or whatever the deal is. However this is `}<em parentName="p">{`not`}</em>{` where the best prizes are. Another beatable thing is the bow and arrow challenge where you have to pop four water balloons that are, obviously, not fully inflated. This one sounds tricky, but it isn't because bows aren't `}<em parentName="p">{`that`}</em>{` hard to shoot, especially not from the distance of two meters ... hell even `}<strong parentName="p">{`I`}</strong>{` could do it, but the girlfriend didn't allow it because she considers me a fumbling idiot. This is also `}<em parentName="p">{`not`}</em>{` where the best prizes are, but they `}<em parentName="p">{`are`}</em>{` better than the duck pond.`}</p>
    <p>{`The funnest of all the activities was the Booster, a long pole-like thing with seats on each end that spins and spins and the seats, of course, also turn around an axis. The sum result is being flown up in the sky to the height of about twelve meters then being plunged back down to earth ... I felt like superman, honestly. The whole ride elicited bouts of laughter from me and screams of sheer terror from the girlfriend.`}</p>
    <p>{`Hell, the fact that she was so scared made the whole ride even better!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      